import { httpClient } from '@/api/httpClient';
import {
  mapPaginatedResource,
  type PaginatedApiResource,
  type PaginatedResult,
} from '@/api/pagination.types';
import {
  mapApiResourceToTenant,
  mapApiResourceToTenantDetail,
  mapApiResourceToTenantListItem,
  mapApiResourceToTenantMember,
  type Tenant,
  type TenantApiResource,
  type TenantDetail,
  type TenantDetailApiResource,
  type TenantListItem,
  type TenantListItemApiResource,
  type TenantMember,
  type TenantMemberApiResource,
} from './tenantsApi.types';

export async function fetchTenants(
  page: number,
  pageSize: number,
  search: string
): Promise<PaginatedResult<TenantListItem>> {
  const trimmedSearch = search.trim();
  const response = await httpClient.get<PaginatedApiResource<TenantListItemApiResource>>(
    '/tenants',
    {
      params: {
        page,
        page_size: pageSize,
        search: trimmedSearch.length === 0 ? undefined : trimmedSearch,
      },
    }
  );
  return mapPaginatedResource(response.data, mapApiResourceToTenantListItem);
}

export async function fetchTenantById(tenantId: string): Promise<TenantDetail> {
  const response = await httpClient.get<TenantDetailApiResource>('/tenants/' + tenantId);
  return mapApiResourceToTenantDetail(response.data);
}

export async function fetchTenantMembers(tenantId: string): Promise<TenantMember[]> {
  const response = await httpClient.get<TenantMemberApiResource[]>(
    '/tenants/' + tenantId + '/members'
  );
  return response.data.map(mapApiResourceToTenantMember);
}

export async function suspendTenant(tenantId: string): Promise<Tenant> {
  const response = await httpClient.post<TenantApiResource>('/tenants/' + tenantId + '/suspend');
  return mapApiResourceToTenant(response.data);
}

export async function activateTenant(tenantId: string): Promise<Tenant> {
  const response = await httpClient.post<TenantApiResource>('/tenants/' + tenantId + '/activate');
  return mapApiResourceToTenant(response.data);
}
